const HurricaneDataStatus = ({ liveError, historicalError, isRefreshing }) => (
  <>
    {liveError && (
      <span className="hurricanes-data-status small" role="alert">
        The latest live storm update failed.
      </span>
    )}
    {historicalError && (
      <span className="hurricanes-data-status small" role="alert">
        The latest historical storm update failed.
      </span>
    )}
    {isRefreshing && (
      <span className="hurricanes-data-status small" role="status">
        Updating...
      </span>
    )}
  </>
);

export default HurricaneDataStatus;
